import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import { Toolbar, ToolbarGroup, ToolbarTitle } from 'material-ui/Toolbar';
import ReactGA from 'react-ga';
import WebexChannels from '../../containers/webex_channels';
import COLORS from '../../theme/colors';

import GA from '../../services/ga_events';

import './webex_source_manager.scss';

export default class WebexSourceManager extends Component {
  static propTypes = {
    user: PropTypes.object,
    teams: PropTypes.array,
    loadWebexUserData: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: undefined,
    teams: undefined,
  };

  componentWillMount() {
    this.props.loadWebexUserData();
  }

  removeWebex() {
    window.location.href = '/api/webex/remove';
  }

  addToWebex() {
    window.location.href = '/api/webex/add';
  }

  render() {
    const { teams } = this.props;
    return (
      <div className="webex-source-manager">
        <Toolbar style={{ backgroundColor: COLORS.blackDark }}>
          <ToolbarGroup
            className="source-info"
            firstChild
          >
            <div className="webex-logo" />
            <ToolbarTitle text="Webex" style={{ color: '#ffffff' }} />
          </ToolbarGroup>
          <ToolbarGroup lastChild>
            {
              this.props.user
                ? <FlatButton
                  label="Remove"
                  style={{ color: COLORS.white }}
                  onClick={() => {
                    ReactGA.event(GA.removeWebex);
                    this.removeWebex();
                  }}
                />
                : <RaisedButton
                  buttonStyle={{ backgroundColor: COLORS.cyanDark }}
                  labelColor={COLORS.white}
                  label="Add Webex"
                  onClick={() => {
                    ReactGA.event(GA.addWebex);
                    this.addToWebex();
                  }}
                />
            }
          </ToolbarGroup>
        </Toolbar>
        <div className="webex-content">
          <div className="info">
            {
              this.props.user
                ? <p> Logged as {this.props.user.displayName} ({this.props.user.email}) </p>
                : 'Connect your Webex to your TeamHub. Click “Add Webex" to get started.'
            }
          </div>
          {
            teams !== undefined && teams && teams.length
              ? <WebexChannels />
              : null
          }
          {
            teams !== undefined && teams && teams.length === 0
              ? <p>You are currently not a part of any team</p>
              : null
          }
        </div>
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/webex_source_manager/webex_source_manager.jsx